'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReply = function ContentReply(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
  );
};
ContentReply = (0, _pure2.default)(ContentReply);
ContentReply.displayName = 'ContentReply';

exports.default = ContentReply;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/content/reply.js
 ** module id = 1326
 ** module chunks = 0
 **/